import React from "react";

const DownloadCTA = () => {
    return (
        <div className="cta-container">
            <h2 className="cta-heading">Download our mobile app?</h2>
            <p className="cta-subtext">Join hundreds of thousands of happy users.</p>
            <div className="cta-buttons">
                <a href="https://apps.apple.com/us/app/conra-smart-construction/id6762303075" target="_blank" rel="noopener noreferrer">
                    <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                        alt="Download on the App Store"
                        className="store-button" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.conra_mobile.app" target="_blank" rel="noopener noreferrer">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                        alt="Get it on Google Play"
                        className="store-button" />
                </a>
            </div>
        </div>
    );
};

export default DownloadCTA;
